import { render, staticRenderFns } from "./FunctionSetUp.vue?vue&type=template&id=133fffcb&scoped=true"
import script from "./FunctionSetUp.vue?vue&type=script&lang=js"
export * from "./FunctionSetUp.vue?vue&type=script&lang=js"
import style0 from "./FunctionSetUp.vue?vue&type=style&index=0&id=133fffcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133fffcb",
  null
  
)

export default component.exports